import React from 'react';

// the muted line under a teacher's name. Slug only — no email/uuid fallback (lineage).
const TeacherSlugLine = ({ slug }) =>
  slug ? <div className="tp-card-field-label">{slug}</div> : null;

export default TeacherSlugLine;
